package org.example.project.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.painterResource
import kotlinproject.composeapp.generated.resources.Res
import kotlinproject.composeapp.generated.resources.as_logo_transparent

@Composable
fun LoginScreen(onGuestLogin: (String) -> Unit) { // WICHTIG: Gibt jetzt den Sprachcode weiter!
    var selectedLang by remember { mutableStateOf(appLanguages[0]) }
    var expanded by remember { mutableStateOf(false) }

    // Lokale Übersetzungen, damit der Login-Screen sofort reagiert
    val subtitleText = mapOf(
        "DE" to "Fordere deinen Geist heraus. Tritt gegen Freunde an. Spaß für die ganze Familie.",
        "EN" to "Challenge your mind. Compete with friends. Fun for the whole family.",
        "ES" to "Desafía tu mente. Compite con amigos. Diversión para toda la familia.",
        "FR" to "Défiez votre esprit. Jouez avec vos amis. Du plaisir pour toute la famille.",
        "IT" to "Sfida la tua mente. Competi con gli amici. Divertimento per tutta la famiglia.",
        "SH" to "Izazovi svoj um. Takmiči se sa prijateljima. Zabava za celu porodicu."
    )
    val guestText = mapOf(
        "DE" to "Als Gast fortfahren", "EN" to "Continue as Guest",
        "ES" to "Continuar como invitado", "FR" to "Continuer comme invité",
        "IT" to "Continua come ospite", "SH" to "Nastavi kao gost"
    )
    val leaderboardText = mapOf(
        "DE" to "Rangliste", "EN" to "Leaderboard",
        "ES" to "Clasificación", "FR" to "Classement",
        "IT" to "Classifica", "SH" to "Rang lista"
    )

    // Hilfsfunktion zum Auslesen der richtigen Sprache
    fun t(dict: Map<String, String>): String = dict[selectedLang.code] ?: dict["DE"] ?: ""

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xFF113E99)),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        // LOGO & TEXT
        Image(
            painter = painterResource(Res.drawable.as_logo_transparent),
            contentDescription = "Logo",
            modifier = Modifier.size(120.dp)
        )
        Text(text = "Tadaa", color = Color.Yellow, fontSize = 28.sp, fontWeight = FontWeight.Bold)

        Spacer(modifier = Modifier.height(24.dp))

        Text(
            text = t(subtitleText),
            color = Color.White,
            fontSize = 11.sp,
            fontWeight = FontWeight.Normal,
            textAlign = TextAlign.Center,
            modifier = Modifier.padding(horizontal = 32.dp)
        )

        Spacer(modifier = Modifier.height(32.dp))

        // 1. SPRACH-DROPDOWN (Im exakten Design der Login-Buttons)
        Box(
            modifier = Modifier
                .fillMaxWidth(0.85f)
                .height(50.dp)
                .background(Color(0xFF3B68B8), RoundedCornerShape(12.dp))
                .border(1.dp, Color(0xFF6B92D4), RoundedCornerShape(12.dp))
                .clickable { expanded = true },
            contentAlignment = Alignment.Center
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Image(
                    painter = painterResource(selectedLang.flagRes),
                    contentDescription = null,
                    modifier = Modifier.size(24.dp)
                )
                Spacer(Modifier.width(12.dp))
                Text(
                    text = selectedLang.name,
                    color = Color.White,
                    fontWeight = FontWeight.Bold,
                    fontSize = 16.sp
                )
            }

            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.background(Color(0xFF3B68B8))
            ) {
                appLanguages.forEach { lang ->
                    DropdownMenuItem(
                        text = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Image(
                                    painter = painterResource(lang.flagRes),
                                    contentDescription = null,
                                    modifier = Modifier.size(20.dp)
                                )
                                Spacer(Modifier.width(12.dp))
                                Text(lang.name, color = Color.White)
                            }
                        },
                        onClick = {
                            selectedLang = lang
                            expanded = false
                        }
                    )
                }
            }
        }

        Spacer(modifier = Modifier.height(16.dp))

        // 2. GAST BUTTON (Gibt den Sprachcode an die App weiter)
        LoginButton(text = t(guestText), onClick = { onGuestLogin(selectedLang.code) })

        Spacer(modifier = Modifier.height(16.dp))

        // 3. RANGLISTE BUTTON
        LoginButton(text = t(leaderboardText), onClick = { })
    }
}

@Composable
fun LoginButton(text: String, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth(0.85f)
            .height(50.dp)
            .background(Color(0xFF3B68B8), RoundedCornerShape(12.dp))
            .border(1.dp, Color(0xFF6B92D4), RoundedCornerShape(12.dp))
            .clickable { onClick() },
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = text,
            color = Color.White,
            fontWeight = FontWeight.Bold,
            fontSize = 16.sp
        )
    }
}